import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { DateService } from '../../../common/date.service';

@Component({
	selector: 'app-timetable-list-filters',
	templateUrl: './timetable-list-filters.component.html',
	styleUrls: ['./timetable-list-filters.component.css'],
})
export class TimetableListFiltersComponent extends FiltersComponent {
	@Input() users: Array<any> = [];
	@Input() side: Array<any> = [];

	filters = {
		name: null,
		created_from: null,
		created_to: null,
		accommodationFrom_from: null,
		accommodationFrom_to: null,
		side: {},
		owner: {},
	};

	filtersDefault() {
		const date = new DateService();
		this.filters.created_from = date.daysAdd(-7);
	}
}
